import React, { useState } from 'react';
import classnames from 'classnames';
import { isArray } from 'lodash';
import './index.scss';
import { navs, settingNavs, getSubNavs } from './config';
import SvgIcon from '../../images/svg/index';
import SpeedBtn from '../SpeedBtn';

export default function Controller({ 
  entryAr, mainActive, carOptions, subActive, subNavVisible, subNavType, settingActive,
  handleNav, handleSubNav, handleSettingNav, differ, loaded
}) {
  const [ pos, setPos ] = useState(0);
  const subNavs = getSubNavs(carOptions);
  const curSubNavs = subNavs[mainActive] || [];
  const curNavs = entryAr ? navs.slice(0, 2) : navs;
  const getSubNavBg = (subNav) => {
    return subNav.bg ? {
      [isArray(subNav.bg) ?
        'backgroundColor': 'backgroundImage'] : isArray(subNav.bg) ?
        `rgb(${subNav.bg.join(',')})` : `url(${require(`../../images/${subNav.bg}`)})`
    } : {}
  }

  const onNav = (value) => {
    if (value === 'setting') {
      setPos(-100);
      value = null;
    }
    handleNav(value);
  }

  return (
    <div>
      <div className="footer-box">
        <div className="footer-wrapper">
          <div className="footer-sub-nav-container">
            <div className="footer-sub-nav-inner">
              <ul className="footer-sub-nav-list" style={{
                display: subNavVisible && curSubNavs.length ? 'flex' : 'none'
              }}>
                {curSubNavs.map((subNav, i) =>
                  <li
                    key={subNav.uid || subNav.value}
                  >
                    <div
                      role="button"
                      className="content"
                      onClick={e => handleSubNav(subNavType, subNav)}
                    >
                      <div
                        className={classnames("inner icon-box", {
                          active: subActive[subNavType] === subNav.uid
                        })}
                        style={subNavType !== 'wheel' ? getSubNavBg(subNav) : {}}
                      >
                        {subNavType === 'wheel' && <img src={require(`../../images/${subNav.bg}`)} alt="" />}
                        {subNav.icon &&
                        <i className={classnames("icon-font")}>
                          { subNav.icon }
                        </i>}
                      </div>
                      <p className="text">{ subNav.name }</p>
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
          {!differ ?
          <div className="footer-wrapper-outside">
            <div className="footer-wrapper-inner" style={{ left: (entryAr ? 0 : pos) + '%' }}>
              <div className="footer-wrapper-left">
                <ul className="footer-main-list footer-nav-main-list">
                  {curNavs.map((v, i) =>
                    <li
                      role="button"
                      key={v.value}
                      onClick={() => {
                        if (entryAr && !['exteriors', 'wheels'].includes(v.value)) return;
                        onNav(v.value);
                      }}
                    >
                      <div className="shadow-box"></div>
                      <div className={classnames("inner", {
                        "active": v.value === mainActive
                      })}>
                        <div>
                          <SvgIcon icon={v.icon}></SvgIcon>
                          <p className="text">{ v.label }</p>
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
              <div className="footer-wrapper-right">
                <ul className="footer-main-list footer-setting-list">
                  {settingNavs.map((v, i) => 
                    <li
                      role="button"
                      key={v.value}
                      onClick={() => {
                        if (i === 0) {
                          setPos(0);
                          return;
                        }
                        handleSettingNav(v.value)
                      }}
                    >
                      <p className="shadow-box"></p>
                      <div className={classnames("inner", {
                        "active": v.value === settingActive
                      })}>
                        <div>
                          <SvgIcon icon={v.icon}></SvgIcon>
                          <p className="text">{ v.label }</p>
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div> :
          <div className="footer-differ-wrapper">
            <ul className="footer-main-list">
              {subNavs.scenes.map((subNav, i) =>
                <li
                  key={subNav.uid || subNav.value}
                >
                  <div
                    role="button"
                    className="content"
                    onClick={e => handleSubNav('scene', subNav)}
                  >
                    <div className={classnames("inner-content", {
                      active: subActive['scene'] === subNav.uid
                    })}>
                      <div
                        className={classnames("inner-img-box", {
                          active: subActive['scene'] === subNav.uid
                        })}
                      >
                      <div
                        className={classnames("img-box", {
                          active: subActive['scene'] === subNav.uid
                        })}
                        style={getSubNavBg(subNav)}
                      >
                        {subNav.icon &&
                        <i className={classnames("icon-font")}>
                          { subNav.icon }
                        </i>}
                      </div>
                    </div>
                    <p className="img-text">{ subNav.name }</p>
                    </div>
                  </div>
                </li>
              )}
            </ul>
          </div>}
        </div>
      </div>
      {differ && loaded &&
      <SpeedBtn
        text="加速对比"
        handleSpeed={() => handleSettingNav('speed')}
      ></SpeedBtn>}
    </div>
  )
}
